import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_CONFIG } from "@/constants/apiConstants";
import { ScraperSuggestion } from "@/services/models/scraperSuggestion";


const simpleFetchBaseQuery = fetchBaseQuery({
    baseUrl: API_CONFIG.BASE_URL.N8N_URL,
});

export const n8nApi = createApi({
    reducerPath: 'n8nApi',
    baseQuery: simpleFetchBaseQuery,
    endpoints: (builder) => ({
        getScraperSuggestions: builder.mutation<ScraperSuggestion, { url: string }>({
            query: (data) => ({
                url: '/scraperGenerator',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const {
    useGetScraperSuggestionsMutation,
} = n8nApi;